module.exports = __webpack_public_path__ + "img/ischool.34b2fab6.png";